import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  leadership: {
    tagline: 'Your leadership drives our mission forward.',
    message: 'Oversee organizational performance, monitor program outcomes, and empower your team to deliver exceptional services that create lasting impact.',
    image: '/myhelp-leadership-banner.webp',
    alt: 'Great leadership inspires people, strengthens organizations, and transforms communities.',
  },
  staff: {
    tagline: 'Your work makes a difference every day.',
    message: 'Manage your caseload, monitor participant progress, and provide the guidance and support needed to help individuals achieve their goals.',
    image: '/myhelp-welcome-banner.webp',
    alt: 'Effective case management creates opportunity, builds stability, and changes lives.',
  },
};

export const bannerImageSrc = (url) => (url && url.startsWith('/api/') ? `${BACKEND_URL}${url}` : url);

// Preview sizes match a ~700px wide banner regardless of screen size.
const SIZES = {
  page: ['text-3xl md:text-lg lg:text-xl xl:text-3xl 2xl:text-[2.75rem]', 'text-base md:text-[11px] lg:text-xs xl:text-sm 2xl:text-xl xl:mt-1.5 2xl:mt-2', 'text-sm md:text-[10px] lg:text-[11px] xl:text-xs 2xl:text-base xl:mt-1.5 2xl:mt-2'],
  preview: ['text-3xl md:text-lg', 'text-base md:text-[11px]', 'text-sm md:text-[10px]'],
};

export const DashboardWelcomeBanner = ({ firstName, isLeadership, banner, testId = 'dashboard-welcome-banner', preview = false }) => {
  const [h1Size, tagSize, msgSize] = SIZES[preview ? 'preview' : 'page'];
  const d = DEFAULTS[isLeadership ? 'leadership' : 'staff'];
  const greeting = banner ? banner.greeting : 'Welcome back';
  const tagline = banner ? banner.tagline : d.tagline;
  const message = banner ? banner.message : d.message;
  const image = banner ? bannerImageSrc(banner.image_url) : d.image;
  const accent = banner?.accent_color || '#922A8C';
  const alt = !banner || banner.is_default ? DEFAULTS[banner?.default_kind || (isLeadership ? 'leadership' : 'staff')].alt : banner.name;
  return (
    <section className="dark-keep relative overflow-hidden rounded-3xl bg-[#F1E8FB] border border-[#922A8C]/10 md:aspect-[2000/453] md:min-h-[180px] md:flex md:items-center" data-testid={testId}>
      <div className={`relative z-10 p-6 md:px-5 md:py-3 md:max-w-[35%] ${preview ? '' : 'xl:px-8'}`} data-testid="dashboard-banner-text">
        <h1 className={`${h1Size} font-extrabold text-[#363636] leading-tight`} data-testid="dashboard-welcome">{greeting}, <span className="whitespace-nowrap">{firstName}!</span></h1>
        {tagline && <p className={`${tagSize} font-semibold mt-1 leading-snug`} style={{ color: accent }} data-testid="dashboard-welcome-tagline">{tagline}</p>}
        {message && <p className={`${msgSize} text-gray-600 mt-1 max-w-lg leading-snug`} data-testid="dashboard-welcome-message">{message}</p>}
      </div>
      {image && <img src={image} alt={alt} className="hidden md:block absolute inset-0 w-full h-full object-cover object-right" data-testid="dashboard-banner-image" />}
    </section>
  );
};
